<template>
  <file-picker
    :user-id="userId"
    :context="context"
    :context-type="contextType"
    :subcontext="subcontext"
    :scope-date-range="scopeDateRange"
    :scope-file-types="scopeFileTypes"
    :max-selection-count="1"
    @close="modal.close()"
    @complete="complete"
  >
    <template #title>
      <span v-if="title">{{ title }}</span>
      <span v-else>Select a thumbnail for <em>"{{name || context.name || 'Unnamed'}}"</em></span>
    </template>

    <template #custom-actions>
      <core-responsive-button
        icon="i-ri-image-edit-fill"
        variant="outline"
        color="charcoal"
        v-if="canEditCustomCover"
        @click="editCustomCover"
      >
        Cover Designer
      </core-responsive-button>
    </template>
  </file-picker>
</template>

<script setup>
  const emit = defineEmits(['complete', 'edit-custom-cover']);
  const props = defineProps({
    modal: Object,
    title: String,
    context: Object,
    contextType: String,
    subcontext: Object,
    name: String,
    canEditCustomCover: Boolean,
    userId: String,
    scopeDateRange: Object,
    scopeFileTypes: Array
  });

  function editCustomCover() {
    emit('edit-custom-cover');
  }

  function complete({items}) {
    emit('complete', items[0]);
  }

</script>
